<template>
	<div style="float: left">
		<button type="button" @click="toggleDropdown" id="transpose-button"><span>{{ currentSong.transpose >= 0 ? '+' : "" }}{{ currentSong.transpose }}</span></button>
		<div id="transpose-dropdown" :class="{ opened: opened, transposed: this.currentSong.transpose !== 0 }">
			<button type="button" @click="transposeMinus" class="transpose">- 1</button>
			<button type="button" @click="transposePlus" class="transpose">+ 1</button>
			<button type="button" @click="setDefaultTranspose" class="set-transpose-button" v-if="this.currentSong.transpose !== 0">{{ $t('song.setTransposeDefault') }}</button>
		</div>
	</div>
</template>

<script>
	import { mapState } from "vuex";
	import { SongService } from "@/services/SongService";
	import Chord from "@/module/chord";
	import chordTranspose from "@/module/chordTranspose";

	export default {
		data() {
			return {
				opened: false
			};
		},
		components: {
		},
		computed: {
			...mapState([ "currentSong" ])
		},
		methods: {
			toggleDropdown() {
				this.opened = !this.opened;
			},
			transposePlus() {
				if (this.currentSong.transpose++ > 10) {
					this.currentSong.transpose = 0;
				}
				this.$store.commit("setCurrentSongTranspose", this.currentSong.transpose);
				SongService.setSongTranspose(this.currentSong);
			},
			transposeMinus() {
				if (this.currentSong.transpose-- < -10) {
					this.currentSong.transpose = 0;
				}
				this.$store.commit("setCurrentSongTranspose", this.currentSong.transpose);
				SongService.setSongTranspose(this.currentSong);
			},
			orientationChanged() {
				this.opened = false;
			},
			setDefaultTranspose() {
				let content = this.currentSong.content.replace(/\[([^\]]*),([^\]]*)]/g, m => m.replace(/,/g, "]["));
				content = content.replace(/\[([^\]]+)]/g, (match, chordString) => {
					var chord = Chord.parse(chordString);
					if (chord === null) {
						return "[" + chordString + "]";
					}
					return "[" + chordTranspose.transpose(chord, "transpose" in this.currentSong ? this.currentSong.transpose : 0).toString() + "]";
				});

				this.$store.commit("setCurrentSongTranspose", this.currentSong.transpose = 0);
				this.$store.commit("setCurrentSongContent", content);

				SongService.setSongContentAndTranspose(this.currentSong);
				this.opened = false;

				this.$notify({
					type: "success",
					text: this.$t("success.defaultTransposeChanged")
				});
			},
			handleOutsideClick(e) {
				if (e.composedPath()) {
					const inside = e.composedPath().find(i => i.id === "transpose-button" || (i.classList && i.classList.contains("transpose")));
					if (!inside) this.opened = false;
				}
			}
		},
		mounted() {
			window.addEventListener("orientationchange", this.orientationChanged);
			window.addEventListener("click", this.handleOutsideClick);
		},
		destroyed() {
			window.removeEventListener("orientationchange", this.orientationChanged);
			window.removeEventListener("click", this.handleOutsideClick);
		}

	}

</script>

<style lang="scss">
	#transpose-button {
		width: 48px;

		span {
			margin: 0 0 0 -7px;
			padding: 0;
		}
	}

	#transpose-dropdown {
		position: absolute;
		top: 50px;
		width: 127px;
		height: 50px;
		background-color: #333a40;
		z-index: 5000;
		border-bottom-right-radius: 4px;
		border-bottom-left-radius: 4px;
		opacity: 0;
		visibility: hidden;

		-webkit-transition: opacity 0.2s;
		-moz-transition: opacity 0.2s;
		-o-transition: opacity 0.2s;
		transition: opacity 0.2s;

		&.transposed {
			height: 105px;
		}

		&.opened {
			opacity: 1;
			visibility: visible;
		}

		button.transpose {
			line-height: 20px;
			height: 47px;

			&:nth-child(1) {
				margin: 0 2px 2px 2px;
			}

			&:nth-child(2) {
				margin: 0 2px 2px 0;
			}
		}

		button.set-transpose-button {
			padding: 5px;
			margin: 0 2px 2px 2px;
			width: 121px;
			background-color: #ef904e;
			line-height: 22px;
			font-size: 16px;
		}
	}

	.mainbar-extended {
		#transpose-dropdown {
			top: 100px;
		}
	}

	@media only screen and (max-width: 400px) {
		#transpose-dropdown {
			top: 52px !important;
		}
	}

	@media only screen and (max-width: 340px) {
		#transpose-dropdown {
			top: 56px !important;
		}
	}

</style>
